export const state = () => ({
  publications: [],
  selectedPublication: null,
  isLoading: false,
  collections: [],
  magazines: [],
  countries: [],
  filters: {}
})

export const mutations = {
  setPublications(state, newPublications) {
    state.publications = newPublications
  },

  addPublications(state, newPublications) {
    state.publications.push(...newPublications)
  },

  setSelectedPublication(state, publication) {
    state.selectedPublication = publication
  },

  setIsLoading(state, loadingState) {
    state.isLoading = loadingState
  },

  setFilters(state, newFilters) {
    state.filters = { ...state.filters, ...newFilters }
  },

  setMagazines(state, newMagazines) {
    state.magazines = [ ...newMagazines ]
  },

  setCollections(state, newCollections) {
    state.collections = [ ...newCollections ]
  },

  setCountries(state, newCountries) {
    state.countries = [ ...newCountries ]
  }
}

export const getters = {
  publications: (state) => state.publications,
  isLoading: (state) => state.isLoading,
  selectedPublication: (state) => state.selectedPublication,
  filters: (state) => state.filters,

  collections: (state) => state.collections,
  magazines: (state) => state.magazines,
  countries: (state) => state.countries
}